var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dash_temp",attrs:{"title":_vm.title}},[_vm._v(_vm._s(_vm.value)),_c('span',{staticClass:"dash_unit"},[_vm._v(_vm._s(_vm.unit))])])
}
var staticRenderFns = []

export { render, staticRenderFns }